"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const config_1 = require("../config");
const notifications_service_1 = require("./notifications-service");
const websocket_1 = require("./websocket");
const mobile_1 = require("./mobile");
/**
 * Factory method for creating a notify instance.
 * @param params set of requirements and optional arguments for configuring notify support of various transports using various libraries.
 */
function createNotify(params = {}) {
    const { websocket, firebase, ios, iosVoip } = params;
    const autoReconnect = websocket && websocket.autoReconnect;
    const mqttSocket = !websocket ? undefined :
        new websocket_1.MqttSocket({ clientId: websocket.deviceId, clientFactory: websocket.pahoMqtt });
    let mobileTransports = [];
    if (firebase && firebase.firebase) {
        mobileTransports.push(new mobile_1.FirebaseMessagingWrapper({
            applicationId: firebase.applicationId,
            fcm: firebase.firebase.messaging(),
        }));
    }
    if (firebase && firebase.reactNativeNotifications) {
        mobileTransports.push(new mobile_1.AndroidNotifyWrapper({
            applicationId: firebase.applicationId,
            android: firebase.reactNativeNotifications,
        }));
    }
    if (ios && ios.reactNativeNotifications) {
        mobileTransports.push(new mobile_1.IosNotifyWrapper({
            applicationId: ios.applicationId,
            usePushkit: false,
            ios: ios.reactNativeNotifications,
        }));
    }
    if (iosVoip && iosVoip) {
        mobileTransports.push(new mobile_1.IosNotifyWrapper({
            applicationId: iosVoip.applicationId,
            usePushkit: true,
            ios: iosVoip.reactNativeNotifications,
        }));
    }
    const notify = new notifications_service_1.NotificationsService({
        cloud: params.cloud,
        stage: params.stage,
        version: params.version,
        url: params.url,
        http: params.http,
        hostCache: params.hostCache,
        mqttSocket,
        mobileNotifiers: mobileTransports,
    });
    if (autoReconnect) {
        notify.reconnectLoop = setupMqttReconnect(notify);
    }
    config_1.Config.notifications = notify;
    return notify;
}
exports.createNotify = createNotify;
function setupMqttReconnect(notify) {
    const reconnectionStrategy = new websocket_1.Retry({
        jitterMilliseconds: 500,
        ceilingMilliseconds: 60000,
        growthFunction: i => i * i * 1000,
        retryFunction: () => notify.reestablishMqttSubscriptions(),
    });
    notify.reestablishMqttSubscriptions().catch(_error => reconnectionStrategy.start());
    notify.asDiagnosticsObservable().subscribe(message => {
        if (message.category === 'MqttSocket' && message.data.type === 'disconnected') {
            reconnectionStrategy.start();
        }
    });
    return reconnectionStrategy;
}
